import { useState } from 'react'

import { Event } from '@tribeplatform/gql-client/types'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/index.js'

import { BasicDetails } from './BasicDetails.js'
import { RecurrenceSelectorModal } from './Recurrence/RecurrenceSelectorModal.js'
import { Section } from './Section.js'
import { isRecurringEvent } from './utils.js'

interface Props {
  event: Event
}

export const EventInformationSection = ({ event }: Props) => {
  const isRecurring = isRecurringEvent(event)
  const [showRecurrenceSelector, setShowRecurrenceSelector] = useState(false)

  return (
    <Section
      title={
        <div className="flex items-center gap-x-2 justify-between">
          <T id="Event.BasicDetails.Title" defaultMessage="When and where" />
          {isRecurring && (
            <Button
              className="text-content-muted"
              variant="tertiaryNeutral"
              size="sm"
              leadingIcon={<SvgIcon name="refresh" size="md" />}
              onClick={() => setShowRecurrenceSelector(true)}
            >
              <T
                id="Event.Details.RecurringEvent.SwitchDate"
                defaultMessage="Switch date"
              />
            </Button>
          )}
        </div>
      }
    >
      <BasicDetails event={event} />
      {showRecurrenceSelector && (
        <RecurrenceSelectorModal
          event={event}
          open={showRecurrenceSelector}
          onClose={() => setShowRecurrenceSelector(false)}
        />
      )}
    </Section>
  )
}
